import {ChiSiamoView} from "./chi-siamo.view";
export default ChiSiamoView;
